<template>
  <div :class="`notification ${type}`">
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: ['message', 'type']
}
</script>

<style scoped>
.notification {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 10px 20px;
  border-radius: 5px;
  color: #fff;
  z-index: 99999;
  background-color: #4caf50; /* Green for success */
  border: 3px solid #fff;
}

.success {
  background-color: #4caf50;
}

.error {
  background-color: #f44336;
}
</style>
